import { URLS } from "@app/shared";
import { Link } from "@design-system/components";
import { getLocalizedValue } from "@modules/shared/utils";
import { getCurrentLocaleCode } from "@mongez/localization";
import { PressRelease } from "../type";

export function PressReleasesList({ news }: { news: PressRelease[] }) {
  const locale = getCurrentLocaleCode();

  return (
    <div className="flex w-full flex-col gap-8 bg-[#f7f9fc] py-10 lg:gap-12 lg:py-20">
      <div className="container grid grid-cols-1 items-center gap-7 sm:grid-cols-2 xl:grid-cols-3 2xl:gap-14">
        {news.map((pressNews) => {
          // const { day, month, year } = getFormattedDate(
          //   pressNews.createdAt.timestamp,
          //   locale,
          // );

          return (
            <div
              className="rounded-xl bg-white shadow-lg sm:rounded-2xl lg:rounded-3xl"
              key={pressNews.id}
            >
              <div className="md:h-68 flex h-fit items-center justify-center p-3 xs:h-60 sm:h-[200px] sm:p-4 lg:h-auto lg:p-6">
                <Link
                  to={URLS.pressReleases.view(pressNews.id)}
                  className="h-full w-full cursor-pointer overflow-hidden rounded-xl sm:rounded-2xl lg:rounded-3xl"
                >
                  <div className="relative h-full w-full overflow-hidden rounded-xl border border-slate-300 sm:rounded-2xl lg:rounded-3xl">
                    <img
                      className="h-auto w-full rounded-xl object-cover duration-200 hover:scale-105 sm:rounded-2xl lg:rounded-3xl lg:object-cover"
                      src={getLocalizedValue(pressNews.image)}
                      alt={getLocalizedValue(pressNews.title)}
                    />
                  </div>
                </Link>
              </div>
              <div className="flex flex-col gap-3 px-5 pb-6 md:gap-6 lg:px-8">
                {/* <span className="text-xs font-medium text-marine sm:text-sm md:text-base lg:text-lg">
                  {day} {month} {year}
                </span> */}
                <Link
                  to={URLS.pressReleases.view(pressNews.id)}
                  className="line-clamp-2 cursor-pointer text-sm font-bold text-marine duration-300 hover:underline sm:text-base md:text-lg lg:text-xl h-[40px] sm:h-[50px] md:h-[56px]"
                >
                  {getLocalizedValue(pressNews.title)}
                </Link>
              </div>
            </div>
          );
        })}
      </div>
      {/* <Pagination
        paginationInfo={{
          currentPage: 1,
          itemsPerPage: 15,
          currentResults: 15,
          numberOfPages: 8,
          totalRecords: 120,
        }}
      /> */}
    </div>
  );
}
